var __default__ = {root:'m_db6d6462',section:'m_2242eb65','stripes-animation':'m_81a374bd',label:'m_91e40b74'};
export default __default__;